import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const ProjectNavigationWrapper = styled.div`
  .view-project-fee-wrapper {
    margin: 32px 0;
    ${responsive.MOBILE`
        margin: 0 0 16px 0;  
    `}
  }
`;
